/* Suprimal welcome pop-up (sections/suprimal-scratch-welcome): offer gate → scratch → claim with email → optional phone → code. Loaded by that section. */
(function () {
  var root = document.querySelector('[data-spw]');
  if (!root || root.__spw) return;
  root.__spw = true;

  var cfg = {
    key: root.getAttribute('data-key'),
    list: root.getAttribute('data-list'),
    code: root.getAttribute('data-code') || 'WELL20',
    delay: Math.max(0, parseInt(root.getAttribute('data-delay'), 10) || 8) * 1000,
    reshowDays: parseInt(root.getAttribute('data-reshow'), 10) || 7,
    phoneStep: root.getAttribute('data-phone') === 'true',
    gate: root.getAttribute('data-gate') === 'true',
    design: root.getAttribute('data-design') === 'true',
    source: root.getAttribute('data-source') || 'Scratch-off welcome form'
  };
  var REVISION = '2026-07-15';
  var STORE_KEY = 'spw_state_v2';

  var $ = function (sel) { return root.querySelector(sel); };
  var dialog = $('[data-spw-dialog]');
  var scrim = $('[data-spw-scrim]');
  var teaser = $('[data-spw-teaser]');
  var canvas = $('[data-spw-foil]');
  var steps = root.querySelectorAll('[data-spw-step]');
  var ORDER = ['offer', 'scratch', 'email', 'phone', 'revealed'];
  var state = { step: cfg.gate ? 'offer' : 'scratch', email: '', phone: '', viaSms: false, painted: false, touched: false, opened: false };
  var lastFocus = null;

  function readStore() { try { return JSON.parse(localStorage.getItem(STORE_KEY) || '{}'); } catch (e) { return {}; } }
  function writeStore(patch) { try { var s = readStore(); for (var k in patch) s[k] = patch[k]; localStorage.setItem(STORE_KEY, JSON.stringify(s)); } catch (e) {} }
  function daysSince(ts) { return ts ? (Date.now() - ts) / 86400000 : Infinity; }

  /* Where to pick up, from what they already did. */
  function resumeStep(s) {
    if (s.revealed) return 'revealed';
    if (s.subscribed) return cfg.phoneStep ? 'phone' : 'revealed';
    if (s.scratched) return 'email';
    if (s.optin || !cfg.gate) return 'scratch';
    return 'offer';
  }

  var CODE_LOCK = { email: 'Claim with your email', phone: 'One step to go' };
  function setStep(name) {
    state.step = name;
    for (var i = 0; i < steps.length; i++) steps[i].hidden = steps[i].getAttribute('data-spw-step') !== name;
    for (var j = 0; j < ORDER.length; j++) dialog.classList.toggle('is-step-' + ORDER[j], ORDER[j] === name);
    var idx = ORDER.indexOf(name);
    dialog.classList.toggle('is-locked', name === 'offer');
    dialog.classList.toggle('is-scratch', name === 'scratch');
    dialog.classList.toggle('is-foil-off', idx >= 2);
    dialog.classList.toggle('is-code-locked', name === 'email' || name === 'phone');
    dialog.classList.toggle('is-revealed', name === 'revealed');
    dialog.classList.toggle('is-compact', idx >= 2);
    dialog.setAttribute('aria-labelledby', 'spw-title-' + name);
    var cl = $('[data-spw-code-lock-label]');
    if (cl && CODE_LOCK[name]) cl.textContent = CODE_LOCK[name];
    var focusMap = { offer: '[data-spw-dialog]', scratch: '[data-spw-dialog]', email: '#spw-email', phone: '#spw-phone', revealed: '[data-spw-copy]' };
    var f = $(focusMap[name]);
    if (f && state.opened) setTimeout(function () { try { f.focus({ preventScroll: name !== 'email' && name !== 'phone' }); } catch (e) {} }, 80);
    /* The ticket changes size between steps on phones: give the foil its new box, unless it's already scratched. */
    if (name === 'scratch') { sizeFoil(); requestAnimationFrame(sizeFoil); }
  }

  function open() {
    if (state.opened) return;
    state.opened = true;
    lastFocus = document.activeElement;
    teaser.hidden = true;
    scrim.hidden = false;
    dialog.hidden = false;
    if (!cfg.design) document.documentElement.style.overflow = 'hidden';
    setStep(state.step);
    sizeFoil();
    requestAnimationFrame(sizeFoil);
    writeStore({ seen: Date.now() });
  }
  function close() {
    if (!state.opened) return;
    state.opened = false;
    scrim.hidden = true;
    dialog.hidden = true;
    document.documentElement.style.overflow = '';
    var s = readStore();
    if (s.subscribed && state.step === 'revealed') { teaser.hidden = true; }
    else { writeStore({ dismissed: Date.now() }); if (!s.teaserHidden || daysSince(s.teaserHidden) > cfg.reshowDays) teaser.hidden = false; }
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---------- Klaviyo ---------- */
  function subscribe(extra) {
    var attrs = { properties: { 'Signup form': cfg.source, 'Welcome code': cfg.code } };
    var subs = {};
    if (state.email) { attrs.email = state.email; subs.email = { marketing: { consent: 'SUBSCRIBED' } }; }
    if (extra && extra.phone) {
      attrs.phone_number = extra.phone;
      attrs.properties['SMS consent collected at'] = new Date().toISOString();
      attrs.properties['SMS consent source'] = cfg.source;
      subs.sms = { marketing: { consent: 'SUBSCRIBED' } };
    }
    attrs.subscriptions = subs;
    var body = { data: { type: 'subscription', attributes: { custom_source: cfg.source, profile: { data: { type: 'profile', attributes: attrs } } }, relationships: { list: { data: { type: 'list', id: cfg.list } } } } };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': REVISION },
      body: JSON.stringify(body)
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  }
  function savePhoneOnly(phone) {
    /* Fallback if the account can't record SMS consent yet: keep the number on the profile as a property. */
    var attrs = { properties: { 'Phone (SMS consent pending)': phone, 'SMS consent collected at': new Date().toISOString(), 'SMS consent source': cfg.source } };
    if (state.email) attrs.email = state.email; else attrs.phone_number = phone;
    var body = { data: { type: 'subscription', attributes: { custom_source: cfg.source, profile: { data: { type: 'profile', attributes: attrs } } }, relationships: { list: { data: { type: 'list', id: cfg.list } } } } };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.key), {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': REVISION }, body: JSON.stringify(body)
    }).catch(function () {});
  }
  function identify() {
    try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: state.email }); } catch (e) {}
  }
  /* Shopify customer record, so the first-order-only code recognises this shopper at checkout. */
  function createShopifyCustomer() {
    try {
      var fd = new FormData();
      fd.append('form_type', 'customer');
      fd.append('utf8', '✓');
      fd.append('contact[email]', state.email);
      fd.append('contact[tags]', 'newsletter,scratch-welcome');
      return fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'contact', { method: 'POST', body: fd, credentials: 'same-origin' }).catch(function () {});
    } catch (e) {}
  }

  /* ---------- Step 0: the offer ---------- */
  var yesBtn = $('[data-spw-yes]');
  var noBtn = $('[data-spw-no]');
  if (yesBtn) yesBtn.addEventListener('click', function () { writeStore({ optin: Date.now() }); setStep('scratch'); });
  if (noBtn) noBtn.addEventListener('click', function () { writeStore({ declined: Date.now() }); close(); });

  /* ---------- Step 1: scratch (the foil comes off, the code stays sealed until the email) ---------- */
  function scratched() {
    if (state.step !== 'scratch') return;
    drawing = false; dialog.classList.remove('is-scratching');
    writeStore({ scratched: Date.now() });
    setStep('email');
  }
  $('[data-spw-reveal]').addEventListener('click', scratched);

  /* ---------- Step 2: claim with an email ---------- */
  var emailForm = $('[data-spw-email-form]');
  var emailInput = $('#spw-email');
  var emailErr = $('[data-spw-email-error]');
  emailForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var v = (emailInput.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
      emailErr.textContent = 'Enter a valid email address, like you@example.com.';
      emailErr.hidden = false; emailInput.setAttribute('aria-invalid', 'true'); emailInput.focus();
      return;
    }
    emailErr.hidden = true; emailInput.removeAttribute('aria-invalid');
    state.email = v;
    var btns = emailForm.querySelectorAll('button[type="submit"]');
    for (var i = 0; i < btns.length; i++) { btns[i].disabled = true; btns[i].setAttribute('data-label', btns[i].textContent); btns[i].textContent = 'Claiming…'; }
    subscribe().then(function (ok) {
      for (var i = 0; i < btns.length; i++) { btns[i].disabled = false; btns[i].textContent = btns[i].getAttribute('data-label'); }
      if (!ok) {
        emailErr.textContent = 'We couldn’t claim it just now. Check your email address and try again.';
        emailErr.hidden = false;
        return;
      }
      writeStore({ subscribed: Date.now() });
      identify();
      createShopifyCustomer();
      if (cfg.phoneStep) setStep('phone'); else reveal();
    });
  });

  /* ---------- Step 3: optional phone ---------- */
  var phoneForm = $('[data-spw-phone-form]');
  var phoneInput = $('#spw-phone');
  var phoneErr = $('[data-spw-phone-error]');
  function fmtPhone(v) {
    var d = String(v || '').replace(/\D/g, '').replace(/^1(?=\d{10})/, '').slice(0, 10);
    if (d.length < 4) return d;
    if (d.length < 7) return '(' + d.slice(0, 3) + ') ' + d.slice(3);
    return '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6);
  }
  if (phoneInput) phoneInput.addEventListener('input', function () { phoneInput.value = fmtPhone(phoneInput.value); phoneErr.hidden = true; });
  if (phoneForm) phoneForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var d = (phoneInput.value || '').replace(/\D/g, '');
    if (d.length !== 10) {
      phoneErr.textContent = 'Enter a 10-digit US mobile number, or skip to your code.';
      phoneErr.hidden = false; phoneInput.setAttribute('aria-invalid', 'true'); phoneInput.focus();
      return;
    }
    phoneInput.removeAttribute('aria-invalid');
    var e164 = '+1' + d;
    state.phone = fmtPhone(d); state.viaSms = true;
    subscribe({ phone: e164 }).then(function (ok) { if (!ok) savePhoneOnly(e164); });
    reveal();
  });
  var skip = $('[data-spw-skip]');
  if (skip) skip.addEventListener('click', function () { state.viaSms = false; reveal(); });

  /* ---------- Step 4: the code ---------- */
  function reveal() {
    setStep('revealed');
    writeStore({ revealed: Date.now() });
    var n = $('[data-spw-reveal-note]');
    if (!n) return;
    var base = n.getAttribute('data-note') || '';
    var extra = state.viaSms ? n.getAttribute('data-note-sms') : n.getAttribute('data-note-email');
    if (extra && state.email) extra = extra.replace('[email]', state.email);
    n.textContent = extra ? base + ' ' + extra : base;
  }

  /* ---------- Scratch foil ---------- */
  function sizeFoil() {
    var r = canvas.getBoundingClientRect();
    if (!r.width) return;
    var dpr = Math.max(2, Math.min(3, window.devicePixelRatio || 1));
    var w = Math.round(r.width * dpr), h = Math.round(r.height * dpr);
    if (canvas.width !== w || canvas.height !== h) { canvas.width = w; canvas.height = h; state.painted = false; }
    if (!state.painted || !state.touched) paint();
  }
  function spaced(ctx, text, cx, cy, font, track) {
    ctx.font = font; ctx.textAlign = 'left';
    var ch = text.split(''), ws = ch.map(function (c) { return ctx.measureText(c).width; });
    var x = cx - (ws.reduce(function (a, b) { return a + b; }, 0) + track * (ch.length - 1)) / 2;
    ch.forEach(function (c, i) { ctx.fillText(c, x, cy); x += ws[i] + track; });
    ctx.textAlign = 'center';
  }
  function paint() {
    var ctx = canvas.getContext('2d', { willReadFrequently: true }); if (!ctx) return;
    var w = canvas.width, h = canvas.height;
    if (!w || !h) return;
    ctx.save(); ctx.globalCompositeOperation = 'source-over'; ctx.clearRect(0, 0, w, h);
    var g = ctx.createLinearGradient(0, 0, w, h);
    g.addColorStop(0, '#2c3329'); g.addColorStop(.55, '#1b201a'); g.addColorStop(1, '#111510');
    ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
    for (var y = 0; y < h; y += 2) { ctx.fillStyle = 'rgba(242,238,229,' + (0.015 + Math.random() * 0.035).toFixed(3) + ')'; ctx.fillRect(0, y, w, 1); }
    var n = Math.round(w * h / 70);
    for (var i = 0; i < n; i++) { ctx.fillStyle = 'rgba(242,238,229,' + (Math.random() * 0.1).toFixed(3) + ')'; ctx.fillRect(Math.random() * w, Math.random() * h, 1.5, 1.5); }
    g = ctx.createLinearGradient(0, h, w, 0);
    g.addColorStop(.28, 'rgba(255,255,255,0)'); g.addColorStop(.46, 'rgba(255,255,255,.1)'); g.addColorStop(.64, 'rgba(255,255,255,0)');
    ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
    var m = Math.round(Math.min(w, h) * .05), rr = m * 1.2;
    ctx.beginPath(); ctx.moveTo(m + rr, m); ctx.arcTo(w - m, m, w - m, h - m, rr); ctx.arcTo(w - m, h - m, m, h - m, rr); ctx.arcTo(m, h - m, m, m, rr); ctx.arcTo(m, m, w - m, m, rr); ctx.closePath();
    ctx.strokeStyle = 'rgba(217,187,159,.55)'; ctx.lineWidth = 2; ctx.stroke();
    var cx = w / 2, cy = Math.round(h * .46), big = Math.round(h * .16), small = Math.round(h * .05); /* a touch above centre: the unlock pill sits along the bottom */
    ctx.fillStyle = '#dcc0a4'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    var s = small * .7, sy = cy - big * 1.15;
    ctx.beginPath(); ctx.moveTo(cx, sy - s); ctx.quadraticCurveTo(cx, sy, cx + s, sy); ctx.quadraticCurveTo(cx, sy, cx, sy + s); ctx.quadraticCurveTo(cx, sy, cx - s, sy); ctx.quadraticCurveTo(cx, sy, cx, sy - s); ctx.closePath(); ctx.fill();
    ctx.font = 'italic 600 ' + big + 'px "SF Pro Display", -apple-system, BlinkMacSystemFont, "SP Inter", "Segoe UI", Roboto, sans-serif';
    ctx.fillText('Scratch here', cx, cy - small * .9);
    ctx.fillStyle = 'rgba(220,192,164,.8)';
    spaced(ctx, 'EVERY CARD WINS', cx, cy + big * .55, '600 ' + small + 'px "SF Pro Text", -apple-system, BlinkMacSystemFont, "SP Inter", "Segoe UI", Roboto, sans-serif', small * .32);
    ctx.restore();
    state.painted = true;
  }
  var drawing = false, last = null, moves = 0;
  function pos(e) { var r = canvas.getBoundingClientRect(); return { x: (e.clientX - r.left) * canvas.width / r.width, y: (e.clientY - r.top) * canvas.height / r.height }; }
  function scratchAt(e) {
    var p = pos(e), ctx = canvas.getContext('2d', { willReadFrequently: true }), b = canvas.width * 0.07;
    ctx.save(); ctx.globalCompositeOperation = 'destination-out'; ctx.fillStyle = '#000'; ctx.strokeStyle = '#000'; ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = b * 2;
    if (last) { ctx.beginPath(); ctx.moveTo(last.x, last.y); ctx.lineTo(p.x, p.y); ctx.stroke(); }
    ctx.beginPath(); ctx.arc(p.x, p.y, b, 0, Math.PI * 2); ctx.fill();
    for (var i = 0; i < 4; i++) { var a = Math.random() * Math.PI * 2, d = b * (.8 + Math.random() * .35); ctx.beginPath(); ctx.arc(p.x + Math.cos(a) * d, p.y + Math.sin(a) * d, b * (.12 + Math.random() * .18), 0, Math.PI * 2); ctx.fill(); }
    ctx.restore(); last = p;
    if (++moves % 6 === 0) check();
  }
  function check() {
    if (state.step !== 'scratch') return;
    var data; try { data = canvas.getContext('2d', { willReadFrequently: true }).getImageData(0, 0, canvas.width, canvas.height).data; } catch (e) { return; }
    var clear = 0, total = 0;
    for (var i = 3; i < data.length; i += 32) { total++; if (data[i] < 60) clear++; }
    if (total && clear / total >= .5) scratched();
  }
  canvas.addEventListener('pointerdown', function (e) {
    if (state.step !== 'scratch') return;
    e.preventDefault(); try { canvas.setPointerCapture(e.pointerId); } catch (err) {}
    drawing = true; state.touched = true; last = null; dialog.classList.add('is-scratching'); scratchAt(e);
  });
  canvas.addEventListener('pointermove', function (e) { if (drawing) { e.preventDefault(); scratchAt(e); } });
  ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (t) { canvas.addEventListener(t, function () { if (!drawing) return; drawing = false; last = null; check(); }); });

  /* ---------- Copy + chrome ---------- */
  var copyBtn = $('[data-spw-copy]'), copyLabel = $('[data-spw-copy-label]'), copyT;
  copyBtn.addEventListener('click', function () {
    try { navigator.clipboard.writeText(cfg.code); } catch (e) {}
    copyLabel.textContent = 'Copied';
    clearTimeout(copyT); copyT = setTimeout(function () { copyLabel.textContent = 'Copy code'; }, 2400);
  });
  $('[data-spw-close]').addEventListener('click', close);
  scrim.addEventListener('click', close);
  /* The tab after closing is itself a yes: it opens on the scratch step, or wherever they left off. */
  $('[data-spw-open]').addEventListener('click', function () {
    writeStore({ optin: readStore().optin || Date.now() });
    state.step = resumeStep(readStore());
    open();
  });
  $('[data-spw-teaser-hide]').addEventListener('click', function () { teaser.hidden = true; writeStore({ teaserHidden: Date.now() }); });
  dialog.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(dialog.querySelectorAll('a[href], button:not([disabled]), input'), function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });
  window.addEventListener('resize', function () { if (state.opened && !state.touched) sizeFoil(); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (!state.touched && state.opened) paint(); });

  /* ---------- When to show ---------- */
  var store = readStore();
  /* Someone who already signed up (or just closed) the previous pop-up shouldn't meet this one as a stranger. */
  if (!store.seen) {
    try {
      var old = JSON.parse(localStorage.getItem('spw_state_v1') || '{}');
      if (old.seen) {
        store = { seen: old.seen, optin: old.optin || old.subscribed || 0, scratched: old.subscribed || 0, subscribed: old.subscribed || 0, revealed: old.revealed || old.subscribed || 0, dismissed: old.dismissed || 0, teaserHidden: old.teaserHidden || 0 };
        writeStore(store);
      }
    } catch (e) {}
  }
  var forced = /[?&]spw=1\b/.test(location.search);
  if (/[?&]spw=reset\b/.test(location.search)) { try { localStorage.removeItem(STORE_KEY); } catch (e) {} store = {}; forced = true; }
  if (!forced) state.step = resumeStep(store);
  if (cfg.design || forced) { open(); }
  else if (store.subscribed) { if (!store.revealed) teaser.hidden = false; /* signed up: stay out of the way, but keep the code one tap away */ }
  else if (store.dismissed && daysSince(store.dismissed) < cfg.reshowDays) {
    if (!store.teaserHidden || daysSince(store.teaserHidden) > cfg.reshowDays) teaser.hidden = false;
  } else {
    /* Wait for the cookie banner / preferences / age check to be dealt with before opening. */
    var blocked = function () {
      var sel = ['[data-sp-consent-card]:not([hidden])', '[data-sp-consent-modal]:not([hidden])', '#AgeVerificationPopup[open]', '.sp-bag[open], .sp-bag.is-open'];
      for (var i = 0; i < sel.length; i++) { try { var el = document.querySelector(sel[i]); if (el && el.offsetParent !== null) return true; } catch (e) {} }
      return false;
    };
    var tries = 0;
    var openWhenClear = function () { if (state.opened) return; if (blocked() && tries++ < 45) { setTimeout(openWhenClear, 2000); return; } open(); };
    var timer = setTimeout(openWhenClear, cfg.delay);
    var onLeave = function (e) { if (e.clientY <= 0 && !e.relatedTarget) { clearTimeout(timer); document.removeEventListener('mouseout', onLeave); openWhenClear(); } };
    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) setTimeout(function () { document.addEventListener('mouseout', onLeave); }, 2500);
  }
  document.addEventListener('shopify:section:select', function (e) { if (root.closest('.shopify-section') && e.target === root.closest('.shopify-section')) open(); });
})();
